import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "lp-wave-content" }
const _hoisted_2 = { class: "lp-wave-login ly-row ly-center-center" }
const _hoisted_3 = { class: "ly-center-center reset-password-container ly-col forgot-password-container lp-load-fadein" }
const _hoisted_4 = {
  key: 0,
  class: "card"
}
const _hoisted_5 = {
  key: 1,
  class: "card"
}
const _hoisted_6 = { class: "msg" }
const _hoisted_7 = { class: "ly-row mt-2" }
const _hoisted_8 = {
  key: 0,
  class: "msg msg-error w-100 text-center"
}

import { useConfigSync } from '@/config/useConfig'
import { LMS } from '@/consts/serviceNames'
import { redirect } from '@/services/redirect'
import { ServiceNames } from '@/types/serviceNames'
import PasswordPoliciesList from '@/views/Common/components/PasswordPoliciesList.vue'
import ResetPasswordSuccessView from '@/views/SetNewPassword/components/ResetPasswordSuccessView.vue'
import { computed, inject, ref, Ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'NewResetPasswordView',
  props: ['expired'],
  setup(__props) {


const props = __props
const oldPassword: Ref<string> = ref('')
const newPassword: Ref<string> = ref('')
const repeatPassword: Ref<string> = ref('')
const showSuccessView: Ref<boolean> = ref(false)
const text: Ref<string> = ref('Your password has expired. Please enter a new one and confirm it.')
const config = useConfigSync()
const resetPasswordFlow = inject('resetPasswordFlow') as (newPassword: string) => Promise<void>
const updatePasswordFlow = inject('updatePasswordFlow') as (oldPassword: string, newPassword: string) => Promise<void>
const usernamePasswordLogin = inject('usernamePasswordLogin') as (username: string, password: string, selectedService: ServiceNames) => Promise<void>
const submitting: Ref<boolean> = ref(false)
const errorMessage: Ref<string> = ref('')

if (props.expired) {
  text.value = "You haven't changed your password in the last 90 days and your account is currently locked. Please fill out the following form to reset your account"
}

const formSubmitted = async () => {
  if (submitting.value || !isNewPasswordValid()) return

  submitting.value = true
  errorMessage.value = ''
  try {
    if (props.expired) {
      await updatePasswordFlow(oldPassword.value, newPassword.value)
      showSuccessView.value = true
    } else {
      await resetPasswordFlow(newPassword.value)
    }
  } catch (error: any) {
    displayError(error)
  } finally {
    submitting.value = false
  }
}

const isNewPasswordValid = () => {
  if (newPassword.value && repeatPassword.value && newPassword.value === repeatPassword.value) {
    return true
  } else {
    return false
  }
}

const onAutoLoginTriggered = async (params: any) => {
  if (submitting.value) return
  submitting.value = true
  try {
    const username = window.sessionStorage.getItem('email') || ''
    if (username === '' || username === undefined) redirect('HomeView')

    const appId: ServiceNames = window.localStorage.getItem('appId') as ServiceNames || LMS
    // After we do the autologin is done we should clean the storage to avoid having inconsistent data in any other flow.
    await usernamePasswordLogin(username, newPassword.value, appId)
    window.sessionStorage.clear()
  } catch (error: any) {
    displayError(error)
  } finally {
    submitting.value = false
  }
}

const disableSubmitButton = computed(() => !isNewPasswordValid() || submitting.value)

const isSymbolsPolicyMeet = computed((): boolean => {
  if (!config.password_policy.require_symbols) return true
  return (/[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-]/.test(newPassword.value))
})

const isLengthPolicyMeet = computed((): boolean => {
  return newPassword.value.length >= config?.password_policy.minimum_length
})

const isLowercasePolicyMeet = computed((): boolean => {
  if (!config.password_policy.require_lowercase) return true
  return (/[a-z]/.test(newPassword.value))
})

const isRequireNumberPolicyMeet = computed((): boolean => {
  if (!config.password_policy.require_numbers) return true
  return /\d/.test(newPassword.value)
})

const isUppercasePolicyMeet = computed((): boolean => {
  if (!config.password_policy.require_uppercase) return true
  return (/[A-Z]/.test(newPassword.value))
})

const displayError = (error: any) => {
  error.message
    ? errorMessage.value = error.message
    : errorMessage.value = 'Unexpected Error'
}


return (_ctx: any,_cache: any) => {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _directive_load_fade_in = _resolveDirective("load-fade-in")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            (showSuccessView.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(ResetPasswordSuccessView, { onLoginSubmitted: onAutoLoginTriggered })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "text-center" }, "Set New Password", -1)),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(text.value), 1),
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(formSubmitted, ["prevent"]),
                    class: "form-reset-password"
                  }, [
                    _createVNode(_component_lp_input, {
                      modelValue: oldPassword.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((oldPassword).value = $event)),
                      type: "password",
                      "label-top": "Old password"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_lp_input, {
                      modelValue: newPassword.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newPassword).value = $event)),
                      type: "password",
                      "label-top": "New password"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_lp_input, {
                      modelValue: repeatPassword.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((repeatPassword).value = $event)),
                      type: "password",
                      "label-top": "Confirm password"
                    }, null, 8, ["modelValue"]),
                    _createVNode(PasswordPoliciesList, {
                      isSymbolsPolicyMeet: isSymbolsPolicyMeet.value,
                      isLengthPolicyMeet: isLengthPolicyMeet.value,
                      isLowercasePolicyMeet: isLowercasePolicyMeet.value,
                      isRequireNumberPolicyMeet: isRequireNumberPolicyMeet.value,
                      isUppercasePolicyMeet: isUppercasePolicyMeet.value
                    }, null, 8, ["isSymbolsPolicyMeet", "isLengthPolicyMeet", "isLowercasePolicyMeet", "isRequireNumberPolicyMeet", "isUppercasePolicyMeet"]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_lp_button, {
                        disabled: disableSubmitButton.value,
                        type: "primary"
                      }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode("Submit", -1)
                        ]))]),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ], 32),
                  (errorMessage.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(errorMessage.value), 1))
                    : _createCommentVNode("", true)
                ]))
          ], 512), [
            [_vShow, true]
          ])
        ]),
        _: 1
      })
    ])), [
      [_directive_load_fade_in, { delay: 1000, timeBetween: 500 }]
    ])
  ]))
}
}

})